import { MadSDKAPIError } from "../../errors/base";
export class FeatureFlagsFetchFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError, "Failed to fetch feature flags.");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FeatureFlagsFetchFailed);
        }
        this.name = "FeatureFlagsFetchFailed";
    }
}
export class FeatureFlagsSaveFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError, "Failed to save feature flags.");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FeatureFlagsSaveFailed);
        }
        this.name = "FeatureFlagsSaveFailed";
    }
}
export class FeatureFlagsPermissionDenied extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError, "You do not have permission to change feature flags.");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FeatureFlagsPermissionDenied);
        }
        this.name = "FeatureFlagsPermissionDenied";
    }
}
//# sourceMappingURL=errors.js.map